/* eslint-disable no-useless-escape */
/* eslint-disable no-shadow */
/* eslint-disable prefer-const */
/* eslint-disable react/no-array-index-key */
/**
 * Ngày tạo: 08/06/2021
 * Mô tả: chọn từ
 */

import { message, Select } from 'antd';
import Loading from 'components/Error/Loading';

import React from 'react';
import { Alert, Button, Card, CardBody, CardFooter, CardHeader } from 'reactstrap';
import PropTypes from 'prop-types';
import QuestionHeader from '../QuestionHeader';
import AudioButton from '../AudioButton';
import './styles.css';

const { Option } = Select;

const SelectWord = ({ data, userData, onSubmit, questionIndex = 0 }) => {
  const [state, setState] = React.useState({
    data: null,
    listInput: [],
    isSubmit: false,
    isDone: false,
  });
  const ref = React.useRef();
  const count = React.useRef(0);
  ref.current = new Audio();

  const playAudio = React.useCallback((audioUrl) => {
    ref.current.src = audioUrl;
    ref.current.play();
  }, []);
  //
  const handleClickInput = React.useCallback(
    (text, index, count) => {
      const { listInput, isSubmit, isDone } = state;
      if (isSubmit) return;
      // paste
      let pure = [];
      pure = listInput.filter((x) => x.index !== count);
      pure.push({ index: count, text });
      // check Done
      // const countInput = listInput.reduce((total, item) => (typeof item === 'string' ? total + 1 : total), 0);
      // isDone = countInput === listInput.length;
      //
      setState((prevState) => ({ ...prevState, listInput: pure, isDone }));
    },
    [state],
  );

  const handleSubmit = React.useCallback(
    (e) => {
      let { isSubmit, listInput, data } = state;
      if (isSubmit) return;
      // isSubmit = true;
      // setState((prevState) => ({ ...prevState, isSubmit }));
      let answersList = data.answers;
      let result = false;
      const isString = typeof answersList === 'string';
      if (isString) {
        answersList = answersList.replace(/\n/g, '');
        answersList = JSON.parse(answersList);
      }
      if (answersList.length === listInput.length) {
        result = listInput.every((x) => x.text === answersList[x.index - 1]);
      }
      const answers = listInput;
      if (onSubmit && typeof onSubmit === 'function') onSubmit({ answers, result });
    },
    [onSubmit, state],
  );
  //
  const listOption = React.useCallback(
    (words) => {
      let wordsChoice = words;
      const isString = typeof words === 'string';
      if (isString) {
        wordsChoice = words.replace(/\n/g, '');
        wordsChoice = JSON.parse(wordsChoice);
      }
      return wordsChoice.map((word, index) => {
        return (
          <Option key={index} value={word}>
            {word}
          </Option>
        );
      });
    },
    [],
  );
  //
  const renderlistWord = React.useCallback((words) => {
    let wordsChoice = words;
    const isString = typeof words === 'string';
    if (isString) {
      wordsChoice = words.replace(/\n/g, '');
      wordsChoice = JSON.parse(wordsChoice);
    }
    return (
      <div className='d-inline-flex mb-4'>
        {wordsChoice.map((word, index) => {
          return (
            <Alert color='warning' key={index} style={{ padding: '10px 15px' }} className='mr-2'>
              <strong style={{ color: 'white' }}>{word}</strong>
            </Alert>
          );
        })}
      </div>
    );
  }, []);
  //
  const renderlistInput = React.useCallback(
    (questions, answers, listInput, words) => {
      // Mặc định là in số ở đầu câu.
      let showNumber = data.settings && data.settings.showNumber;
      if (showNumber === null || showNumber === undefined) {
        showNumber = true;
      }
      const isString = typeof questions === 'string';
      let questionsArray = questions;
      if (isString) {
        questionsArray = questionsArray.replace(/\n/g, '');
        questionsArray = JSON.parse(questionsArray);
      }
      return questionsArray.map((question, index) => {
        if (index === 0) count.current = 0;
        const item_array = question.split(/(\#)/);
        return (
          <div key={index} className='answers-select-word'>
            <span className='questionText'>
              {showNumber && (
                <span>
                  {index + 1}
                  .
                  {' '}
                </span>
              )}
              {item_array.map((item, i) => {
                if (item !== '#') return item;
                count.current++;
                let Color = '#2dce89';
                const selectedIndex = count.current;
                const input = listInput?.find((x) => x.index === selectedIndex);
                // if (state.isSubmit) {
                //   Color = input?.text === answers[index] ? 'green' : 'red';
                // }
                return (
                  <Select
                    key={i}
                    // defaultValue={userData?.answers[index] || ''}
                    // defaultValue={state.listInput[index]}
                    value={input?.text ?? ''}
                    className='inputText-select-word'
                    onChange={(text) => handleClickInput(text, index, selectedIndex)}
                    style={{
                      color: Color,
                    }}
                  >
                    {listOption(words)}
                  </Select>
                );
              })}
            </span>
          </div>
        );
      });
    },
    [data.settings, handleClickInput, listOption],
  );

  React.useEffect(() => {
    let listInput = [];
    if (userData) {
      listInput = userData.answers;
    }
    setState((prevState) => ({ ...prevState, listInput, data, isSubmit: false }));
  }, [data, userData]);

  if (!state.data) return <Loading />;

  const { questions, answers, words, title, subTitle } = state.data;
  return (
    <Card>
      <CardHeader>
        <QuestionHeader title={data.title} subTitle={data.subTitle} questionIndex={questionIndex} tooltip='SelectWord' />
      </CardHeader>
      <CardBody style={{ minHeight: 300 }}>
        <AudioButton audioUrl={data.audioUrl} />
        {renderlistWord(words)}
        {renderlistInput(questions, answers, state.listInput, words)}
      </CardBody>
      <CardFooter>
        <Button color='primary' disabled={state.listInput.length < 1} onClick={handleSubmit}>
          Submit
          <i className='fas fa-arrow-right ml-3' />
        </Button>
      </CardFooter>
    </Card>
  );
};

SelectWord.propTypes = {
  data: PropTypes.object.isRequired,
};

export default SelectWord;
